import React from 'react';
import { Loading } from '../loading/Loading';
import { IActionCheckBox } from 'interfaces/actionCheckBox';

const ActionCheckbox = (props: IActionCheckBox) => {
  const { onChange, checked, disabled, customClass } = props;
  return (
    <>
      {disabled ?
        <Loading type='mini' />
        :
        (<input
          type={'checkbox'}
          checked={checked}
          disabled={disabled}
          className={customClass || ''}
          onChange={e => {
            e.preventDefault();
            onChange(e.target.checked);
          }}
        >
        </input>
        )
      }
    </>
  );
};

export default ActionCheckbox;
